import React from "react";
import { ADVERTISE_SECTION } from "../partnered-data";
import "./advertise-section.m.css";

export const AdvertiseSection = (props) => {
  const {
    contactEmail,
    contactPhone,
  } = props;
  return (
    <section styleName="advertise-section">
      <div styleName="centered">
        <div styleName="content-container">
          <div styleName="advertise-layout">
            <div>
              <h2 styleName="advertise-headline">
                {ADVERTISE_SECTION.headline}
              </h2>
              <p styleName="advertise-description">
                Reach{" "}
                <strong>{ADVERTISE_SECTION.description.reach}</strong> senior
                executives from{" "}
                <strong>{ADVERTISE_SECTION.description.companies}</strong>{" "}
                {ADVERTISE_SECTION.description.text}
              </p>
            </div>

            <div styleName="advertise-contact">
              <p styleName="contact-item">{ADVERTISE_SECTION.contact.label}</p>
              <p styleName="contact-item">
                <span styleName="label">Email</span>
                <span styleName="value">{contactEmail}</span>
              </p>
              <p styleName="contact-item">
                <span styleName="label">Phone</span>
                <span styleName="value">{contactPhone}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
